import Vue from 'vue';
import { initialData } from './state';

export default {
  updateCurrentStep(state, step) {
    state.currentStep = step || initialData().currentStep;
  },
  updateIsPledged(state, IsPledged) {
    state.isPledged = IsPledged;
  },
  update(state, payload) {
    state[payload.key] = payload.data;
  },
  updateSubLookup(state, payload) {
    Vue.set(state[payload.key], payload.relatedId, payload.data);
  },
  updateMainRequest(state, payload) {
    state.mainRequest = payload;
  },
  resetMainRequest(state) {
    state.mainRequest = initialData().mainRequest;
  },
  resetRequestApplicant(state) {
    state.requestApplicant = initialData().requestApplicant;
  },
  updateSubmittedRequestInfo(state, payload) {
    state.mainRequest = payload;
  },
  updateSubmittedApplicantDetails(state, payload) {
    state.requestApplicant = payload;
  },
  updateMainRequestObjectKey(state, objectKey) {
    Vue.set(state.mainRequest, 'objectKey', objectKey);
  },
  updateAuditConfirmations(state, auditConfirmations) {
    state.auditConfirmations = auditConfirmations.reduce((pv, cv) => ({
      ...pv,
      [`flag_${cv.mainRequestAuditFlagId}`]: cv.confirmed,
    }), {});
  },
  setAttachments(state, attachments) {
    state.attachments.data = attachments;
  },
  updateAttachments(state, attachment) {
    if (!state.attachments.data) {
      state.attachments.data = [];
    }
    state.attachments.data.push(attachment);
  },
  deleteAttachment(state, objectKey) {
    state.attachments.data = state.attachments.data.filter(a => a.objectKey !== objectKey);
  },
  setBankruptActivities(state, _activities) {
    state.activities = _activities || initialData().activities;
  },
  resetBankruptActivities(state) {
    state.activities = initialData().activities;
  },
  setRequestSecretaries(state, data) {
    state.secretary = data || initialData().secretary;
  },
  resetRequestSecretaries(state) {
    state.secretary = initialData().secretary;
  },
  setRequestAttorneyDetails(state, data) {
    state.attorneyDetails = data || initialData().attorneyDetails;
  },
  resetRequestAttorneyDetails(state) {
    state.attorneyDetails = initialData().attorneyDetails;
  },
  setRequestDebtorsDetails(state, data) {
    state.debtor = data || initialData().debtor;
  },
  resetRequestDebtorsDetails(state) {
    state.debtor = initialData().debtor;
  },
  setRequestCreditorDetails(state, data) {
    state.creditor = data || initialData().creditor;
  },
  resetRequestCreditorDetails(state) {
    state.creditor = initialData().creditor;
  },
  setMainRequestLoading(state, isLoading) {
    state.isMainRequestLoading = isLoading;
  },
  updateReplies(state, replies) {
    state.replies = replies;
  },
  setCurrentUserInfo(state, userInfo) {
    state.currentUser = userInfo;
  },

};
